<template>
	<div>
		<div class="global-tool-bar">
		    <div class="left-bar">
		        <span class="title">关于我们列表</span>
		    </div>
		</div>
		<stand-pagination-table :columns="mainTable.columns" 
			:data="mainTable.data"
			:loading="mainTable.loading"
			:table-search="mainTable.tableSearch"
			:table-load-event="getAboutTableRecords"
			>
		</stand-pagination-table>
		
		<!-- 编辑关于我们-->
		<Modal v-model="aboutUsFromShow"
		        title="关于我们" width="800px">
		        <Form label-position="top">
					<Row :gutter="16">
					    <Col span="24">
					    <FormItem label="标题">
					        <Input v-model="aboutUsFrom.title"></Input>
					    </FormItem>
					    </Col>
					    <Col span="24">
					    <FormItem label="内容">
							<quill-editor v-model="aboutUsFrom.content"></quill-editor>
					    </FormItem>
					    </Col>
						
					</Row>
				</Form>
				<div slot="footer">
				    <Button type="success"
				        class="form-button"
				        @click="onAboutSave">保存</Button>
				    <Button type="text"
				        class="form-button"
				        @click="onAboutCancel">取消</Button>
				</div>
		    </Modal>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
	
import { quillEditor } from 'vue-quill-editor';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getNoticeList, saveNotice } from '@/api/modules/system-management/notice-management';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import search from '@/libs/search';
export default {
    name:'AboutUs',
    components:{ StandPaginationTable, quillEditor },
    data() {
        return {
            aboutUsFrom:{
                title:'',
                noticeUuid:'',
                content:'',
                noticeType:''
            },
            aboutSource: [],
            aboutUsFromShow:false,
            mainTable:{
                columns:[
                    { title:'序号', type:'index', width: 40, align: 'center' },
                    { title:'标题', key:'title', align: 'center' },
                    { title:'创建时间', key:'createTime', width:120, align: 'center', render: (h, params) => dateTimeRender(h, params.row.createTime) },
                    { title: '修改时间', key: 'modifyTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.modifyTime) },
                    {
					    title: '操作',
					    key: 'action',
					    align: 'center',
					    render: (h, params) => {
					        return h('div', [
					            h('Button', {
					                props: {
					                    type: 'text',
					                    size: 'small'
					                },
					                style: {},
					                on: {
					                    click: () => {
					                        this.onAboutUsUpdate(params.row);
					                    }
					                }
					            }, '编辑')]);
					    }
						
                    }
                ],
                data:[],
                loading:false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted(){
        this.getAboutTableRecords();
    },
    methods: {
        getAboutTableRecords(reset = false){
            this.mainTable.loading = true;
			
            if (reset) {
			    search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({ value: '关于我们', name: 'noticeType', type:'eq' });
            getNoticeList(this.mainTable.tableSearch).then(res => {
			    if (res.code === 0) {
			        this.mainTable.data = res.data.records;
			        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
			    }
			
			    this.mainTable.loading = false;
            }).catch(() => {
			    this.mainTable.loading = false;
            });
        },
        onAboutUsUpdate(row){
            this.aboutUsFrom.noticeUuid = row.noticeUuid;
            this.aboutUsFrom.title = row.title;
            this.aboutUsFrom.content = row.content;
            this.aboutUsFrom.noticeType = '关于我们';
            this.aboutUsFromShow = true;
        },
        onAboutCancel() {
		    this.aboutUsFromShow = false;
        },
        onAboutSave() {
            const data = Object.assign({}, this.aboutUsFrom);
            saveNotice(data).then(res => {
			    if (res.code === 0) {
			        this.$Modal.success({
			            title: '保存成功',
			            onOk: () => {
			                this.aboutUsFromShow = false;
			                this.getAboutTableRecords();
			            }
			        });
			    }
            });
        }
    }
};	
</script>

<style>
</style>
